<div class="row">

  <div style="max-width:500px; width:100%; margin:auto; text-align:center">
    Logging out, please wait...
  </div>
</div>
